import React from 'react';
import { LoadIcon } from 'assests/GmsIcons';

type TGenerateStatusProps = {
    isGenerate: boolean;
    isPromote: boolean;
}

const GenerateStatus: React.FC<TGenerateStatusProps> = ({ isGenerate, isPromote }) => {
    const generateMessage = 'Generate in progress ...';
    const promoteMessage = 'Promote in progress ...  ';

    const messages = [];
    if (isGenerate) messages.push(generateMessage);
    if (isPromote) messages.push(promoteMessage);

    if (messages.length === 0) return null;

    return (
        <div className="tw-flex tw-flex-col tw-items-center tw-w-auto tw-px-2 tw-py-1 tw-bg-[#fff0b3] tw-rounded">
            {messages.map((message, index) => (
                <div key={index} className="tw-flex tw-justify-center tw-text-[#5E5942] tw-items-center tw-gap-2 tw-text-center tw-h-auto">
                    <label>{message}</label>
                    <LoadIcon />
                </div>
            ))}
        </div>
    );
}

export default GenerateStatus;